import FlashcardsAPI from "@/services/api/flashcards"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const useUpdateDeck = (flashcardId: string) => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: ["update-deck"],
    mutationFn: FlashcardsAPI.updateDeck,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-flashcard", flashcardId] })
    },
  })
  return mutation
}

export default useUpdateDeck
